import styled, { css } from 'styled-components';

export const Listbox = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 168px;
  background-color: ${({ theme }) => theme.donedeal.colors.WHITE};
  outline: none;
`;

export const Option = styled.li<{ $selected: boolean }>`
  ${({ theme }) => theme.donedeal.fontSize.M16};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  padding: ${({ theme }) => `${theme.spacing.S12} ${theme.spacing.M16}`};
  white-space: nowrap;
  cursor: ${({ $selected }) => ($selected ? 'default' : 'pointer')};
  font-weight: ${({ $selected, theme }) =>
    $selected
      ? theme.donedeal.fontWeight.bold
      : theme.donedeal.fontWeight.regular};

  ${({ $selected, theme }) =>
    !$selected &&
    css`
      &:hover,
      &:focus,
      &:focus-visible {
        background-color: ${theme.donedeal.colors.GREY_LIGHTER};
        outline: none;
      }
    `}
`;
